import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-fcf82d68"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "step-three"
};
var _hoisted_2 = {
  class: "video-box"
};
var _hoisted_3 = {
  class: "camera-area"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "camera-tips"
  }, " *按照示例进行拍照验证（手持“有效证件”或“准考证”） ", -1);
});
var _hoisted_5 = {
  class: "camera-cover"
};
var _hoisted_6 = {
  key: 0,
  class: "camera-photo-url"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "camera-video"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "lt"
  }, null, -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "rt"
  }, null, -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "lb"
  }, null, -1);
});
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "rb"
  }, null, -1);
});
var _hoisted_13 = {
  key: 0,
  class: "count-down"
};
var _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"camera-tips-area\" data-v-fcf82d68><div class=\"tips-title\" data-v-fcf82d68><span class=\"line\" data-v-fcf82d68></span><span class=\"title\" data-v-fcf82d68>注意事项</span><span class=\"line\" data-v-fcf82d68></span></div><ul class=\"tips-list\" data-v-fcf82d68><li class=\"tips-item\" data-v-fcf82d68><div class=\"img\" data-v-fcf82d68></div><div class=\"txt\" data-v-fcf82d68>正脸面对摄像头</div></li><li class=\"tips-item\" data-v-fcf82d68><div class=\"img\" data-v-fcf82d68></div><div class=\"txt\" data-v-fcf82d68>不要晃动防止模糊</div></li><li class=\"tips-item\" data-v-fcf82d68><div class=\"img\" data-v-fcf82d68></div><div class=\"txt\" data-v-fcf82d68>不要多人入镜</div></li><li class=\"tips-item\" data-v-fcf82d68><div class=\"img\" data-v-fcf82d68></div><div class=\"txt\" data-v-fcf82d68>人物不要出画框</div></li></ul></div>", 1);
var _hoisted_15 = {
  class: "action-step"
};
var _hoisted_16 = /*#__PURE__*/_createTextVNode(" 下一步 ");
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("i", {
    class: "refresh-icon"
  }, null, -1);
});
var _hoisted_18 = /*#__PURE__*/_createTextVNode(" 重新拍照 ");
var _hoisted_19 = [_hoisted_17, _hoisted_18];
var _hoisted_20 = /*#__PURE__*/_createTextVNode(" 开始拍照验证 ");
import { EnvCheckerService } from '@/services/env/checker.service';
import { useService } from '@kaokei/use-vue-service';
import { debounce } from 'lodash-es';
import { onMounted, onUnmounted, watch, reactive, ref } from 'vue';
// import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  emits: ['update-step'],
  setup: function (__props, _a) {
    var _this = this;
    var emit = _a.emit;
    var PhotoKaCaAudioUrl = 'https://img.pipacoding.com/competition/materials/kaca.mp3';
    var checkerService = useService(EnvCheckerService);
    // const route = useRoute();
    var TimeCount = 5;
    var microVideoRef = ref();
    var PhotoDataBlob = null;
    var setTakePhotoAnimate = ref(false);
    var PhotoState = reactive({
      // 开始拍照
      startPhoto: checkerService.photoDataUrl ? true : false,
      // 是否已经拍过照片了
      hasPhotoed: checkerService.photoDataUrl ? true : false,
      // 倒计时时间
      times: TimeCount,
      showCount: false,
      photoDataUrl: checkerService.photoDataUrl,
      canNextLoading: false
    });
    var timer;
    var audioEl = new Audio();
    audioEl.src = PhotoKaCaAudioUrl;
    var countDownTime = function () {
      if (!checkerService.stream) {
        // 可能未开启摄像头和mic
        checkerService.NoDeviceVisible = true;
        return;
      }
      clearInterval(timer);
      PhotoState.times = TimeCount;
      PhotoState.showCount = true;
      PhotoState.hasPhotoed = false;
      timer = setInterval(function () {
        PhotoState.times -= 1;
        if (PhotoState.times <= 1) {
          setTakePhotoAnimate.value = true;
        }
        if (PhotoState.times <= 0) {
          PhotoState.showCount = false;
          setTakePhotoAnimate.value = false;
          audioEl === null || audioEl === void 0 ? void 0 : audioEl.play();
          clearInterval(timer);
          takePhoto();
        }
      }, 1000);
    };
    var takePhoto = function () {
      if (!checkerService.stream) {
        // 可能未开启摄像头和mic
        checkerService.NoDeviceVisible = true;
        return;
      }
      if (microVideoRef.value) {
        var canvas_1 = document.createElement('canvas');
        canvas_1.width = microVideoRef.value.videoWidth;
        canvas_1.height = microVideoRef.value.videoHeight;
        var context = canvas_1.getContext('2d');
        if (context) {
          context.drawImage(microVideoRef.value, 0, 0, canvas_1.width, canvas_1.height);
          var urlCreator_1 = window.URL || window.webkitURL;
          canvas_1.toBlob(function (blob) {
            if (!blob) return;
            var url = urlCreator_1.createObjectURL(blob);
            PhotoState.photoDataUrl = url;
            checkerService.photoDataUrl = url;
            PhotoState.hasPhotoed = true;
            PhotoDataBlob = blob;
            canvas_1 = null;
          }, 'image/png');
        }
      }
    };
    var onStartPhoto = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (checkerService.stream) {
            PhotoState.startPhoto = true;
            countDownTime();
          } else {
            // 可能未开启摄像头
            checkerService.NoDeviceVisible = true;
          }
          return [2 /*return*/];
        });
      });
    };
    var onNextStep = debounce(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var res, url, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!PhotoDataBlob) return [3 /*break*/, 5];
              PhotoState.canNextLoading = true;
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4 /*yield*/, checkerService.uploadFaceUrl(PhotoDataBlob)];
            case 2:
              res = _a.sent();
              url = res.Location;
              checkerService.updateFaceCheckResult(url).then(function () {
                checkerService.goStep(3);
              }).catch(function () {
                checkerService.photoDataUrl = '';
              }).finally(function () {
                PhotoState.canNextLoading = false;
              });
              return [3 /*break*/, 4];
            case 3:
              e_1 = _a.sent();
              checkerService.photoDataUrl = '';
              PhotoState.canNextLoading = false;
              return [3 /*break*/, 4];
            case 4:
              return [3 /*break*/, 6];
            case 5:
              if (checkerService.photoDataUrl) {
                checkerService.goStep(3);
              }
              _a.label = 6;
            case 6:
              return [2 /*return*/];
          }
        });
      });
    }, 210);
    onMounted(function () {
      watch(function () {
        return checkerService.stream;
      }, function (newStream) {
        if (microVideoRef.value) {
          microVideoRef.value.srcObject = newStream;
        }
      }, {
        immediate: true
      });
    });
    onUnmounted(function () {
      if (audioEl) {
        audioEl.pause();
      }
      audioEl = null;
      clearInterval(timer);
    });
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_unref(PhotoState).hasPhotoed ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
        src: _unref(PhotoState).photoDataUrl,
        alt: ""
      }, null, 8, _hoisted_7)])) : _createCommentVNode("", true), !_unref(PhotoState).startPhoto && !_unref(PhotoState).hasPhotoed ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "camera-ex",
        style: _normalizeStyle(_unref(checkerService).faceCheckStandardUrl ? {
          backgroundImage: 'url(' + _unref(checkerService).faceCheckStandardUrl + ')',
          backgroundSize: '454px 340px'
        } : {})
      }, null, 4)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_8, [_createElementVNode("video", {
        class: "video-monitor",
        ref: function (_value, _refs) {
          _refs['microVideoRef'] = _value;
          microVideoRef.value = _value;
        },
        autoplay: "",
        playsinline: "",
        muted: ""
      }, null, 512)], 512), [[_vShow, _unref(checkerService).stream && _unref(PhotoState).startPhoto]]), _createElementVNode("div", {
        class: _normalizeClass(["camera-corner", {
          'camera-taked': setTakePhotoAnimate.value
        }])
      }, [_hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12, _unref(PhotoState).showCount ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(PhotoState).times), 1)) : _createCommentVNode("", true)], 2)])]), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_unref(PhotoState).startPhoto ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_a_button, {
        type: "primary",
        class: "next-step",
        disabled: !_unref(PhotoState).hasPhotoed,
        loading: _unref(PhotoState).canNextLoading,
        onClick: _unref(onNextStep)
      }, {
        default: _withCtx(function () {
          return [_hoisted_16];
        }),
        _: 1
      }, 8, ["disabled", "loading", "onClick"]), _createElementVNode("div", {
        class: "refresh-photo",
        onClick: countDownTime
      }, _hoisted_19)], 64)) : (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        type: "primary",
        class: "start-photo",
        onClick: onStartPhoto
      }, {
        default: _withCtx(function () {
          return [_hoisted_20];
        }),
        _: 1
      }))])]);
    };
  }
});